import Button from "./Button";
import Monitor from "./Monitor";

export default {
  Button,
  Monitor
};
